import { render, staticRenderFns } from "./pcModule2.vue?vue&type=template&id=9cf76400&scoped=true"
import script from "./pcModule2.vue?vue&type=script&lang=js"
export * from "./pcModule2.vue?vue&type=script&lang=js"
import style0 from "./pcModule2.vue?vue&type=style&index=0&id=9cf76400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf76400",
  null
  
)

export default component.exports